import { render } from "./Secteur.vue?vue&type=template&id=5dbc2af5"
import script from "./Secteur.vue?vue&type=script&lang=js"
export * from "./Secteur.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__